import { useContext } from 'react';
import { PlatformAuthContext } from '../contexts/PlatformAuthContext';

export default function usePlatformAuth() {
  const context = useContext(PlatformAuthContext);

  if (!context) {
    throw new Error('usePlatformAuth must be used within a PlatformAuthProvider');
  }

  return context;
}
